export default __webpack_public_path__ + "static/media/iconTicTac.e8b6447b.svg";